export default class WidgetGuestSuiteEnum {
    static GUESTSUITE = '[data-element="widget-guest-suite"]'
    static GUESTSUITE_RATING = '[data-element="widget-guest-suite-rating"]'
    static GUESTSUITE_REVIEWS = '[data-element="widget-guest-suite-reviews"]'
}
